import Loadable from "app/components/Loadable";
import { PERMISSIONS } from "app/utils/permissions";
import { lazy } from "react";

const FieldAttendanceLog = Loadable(lazy(() => import("./FieldAttendanceLog")));
const FieldAttendanceLogForm = Loadable(lazy(() => import("./FieldAttendanceLogForm")));
const DailyAttendanceSummary = Loadable(
  lazy(() => import("./DailyAttendanceSummary"))
);

const attendanceRoutes = [
  {
    path: "/Attendance/FieldAttendanceLog",
    element: <FieldAttendanceLog />,
    permission: PERMISSIONS.Attendances.Menu,
  },
  {
    path: "/Attendance/FieldAttendanceLogForm",
    element: <FieldAttendanceLogForm />,
  },
  {
    path: "/Attendance/FieldAttendanceLogForm/:attendanceId",
    element: <FieldAttendanceLogForm />,
  },
  {
    path: "/Attendance/DailyAttendanceSummary",
    element: <DailyAttendanceSummary />,
    permission: [
      PERMISSIONS.Attendances.Employee_Wise_Attendance,
      PERMISSIONS.Attendances.Daily_Employee_Attendance_Report,
      PERMISSIONS.Attendances.Daily_Employee_Attendance_Excel_Report,
      PERMISSIONS.Attendances.Employee_Attendance_Report,
      PERMISSIONS.Attendances.Employee_Attendance_Excel_Report,
      PERMISSIONS.Attendances.Employee_Attendance_Summary_Report,
      PERMISSIONS.Attendances.Employee_Attendance_Summary_Excel_Report,
    ],
  },
];
export default attendanceRoutes;
